import {logger as SentryLogger} from '@sentry/react';
import {IVehicle} from "@services/Vehicles/Vehicles";

export type ExchangeVehicle = {
  id: string;
  make: string;
  model: string;
  year: string;
  color: string;
  license_plate: string;
  vin: string;
  current_meter_value: number;
  body_type: string;
  group_ancestry: string
};

export type CurrentVehicleState = {
  vehicle: ExchangeVehicle;
  fleetioStatusId: string;
  fleetioStatusName: string;
  endingOdometer: number;
};

export const defaultExchangeVehicle: ExchangeVehicle = {
  id: '',
  make: '',
  model: '',
  year: '',
  color: '',
  license_plate: '',
  vin: '',
  current_meter_value: 0,
  body_type: '',
  group_ancestry: ''
};

export type CurrentVehicleAction =
  | { type: "SET_FLEETIO_STATUS"; payload: { id: string; name: string } }
  | { type: "SET_ENDING_ODOMETER"; payload: any }
  | { type: "SET_VEHICLE"; payload: IVehicle };


export const currentVehicleInitialState: CurrentVehicleState = {
  vehicle: defaultExchangeVehicle,
  fleetioStatusId: "",
  fleetioStatusName: "",
  endingOdometer: 0
};


export function currentVehicleReducer(
  state: CurrentVehicleState,
  action: CurrentVehicleAction
): CurrentVehicleState {
  switch (action.type) {
    case "SET_FLEETIO_STATUS":
      SentryLogger.debug(`Setting Fleetio status with id: ${action.payload.id} and name: ${action.payload.name}`);
      return {
        ...state,
        fleetioStatusId: action.payload.id,
        fleetioStatusName: action.payload.name,
      };
    case "SET_ENDING_ODOMETER":
      SentryLogger.debug(`Setting ending odometer with value: ${action.payload}`);
      return {
        ...state,
        endingOdometer: action.payload,
      };
    case "SET_VEHICLE":
      // convert IVehicle to ExchangeVehicle
      const convertedVehicle = {
        id: action.payload.id,
        make: action.payload.make,
        model: action.payload.model,
        year: action.payload.year,
        color: action.payload.color,
        license_plate: action.payload.license_plate,
        vin: action.payload.vin,
        current_meter_value: action.payload.current_meter_value,
        body_type: action.payload.specs?.body_type || '',
        group_ancestry: action.payload.group_ancestry || ''
      };
      return {...state, vehicle: convertedVehicle};
    default:
      console.error(`Error - incorrect action sent ${action} ${state}`)
      return state;
  }
}
